import React from "react";
import { IoWarningOutline } from "react-icons/io5";
import { FaBell } from "react-icons/fa6";
import classNames from "classnames";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import styles from "./module.style.scss";

const MessageItem = ({ item, onDelete, isRemoveMy = true }) => {
  return (
    <div
      className={classNames("top-strip-alert-container", {
        ["warning-strip"]: item.isWarning,
        ["success-strip"]: item.isSuccess,
        ["my-2"]: isRemoveMy,
      })}
    >
      <div className="d-flex align-items-center justify-content-center gap-md">
        {item.isWarning && (
          <IoWarningOutline style={{ color: "#705010" }} size={18} />
        )}
        {item.isSuccess && <FaBell style={{ color: "#07794C" }} size={18} />}
        <div className="global-font-size text-bold">{item.content}</div>
        <div className="cross-icon">
          <CrossIcon onClick={onDelete} />
        </div>
      </div>
    </div>
  );
};

export default MessageItem;
